// Backend hosts per VITE_API_ENV key (see README "Local development environment"
// and useConfig getDefault*). The keys are intended PROFILES, not a guarantee that
// every map follows them — services have per-map exceptions, so read each map for
// its actual host. Rough intent per key:
//   sandbox     — LOCAL development: localhost hosts you run yourself (the default
//                 when VITE_API_ENV is unset). Exception: POI has no local host, so
//                 it points at staging even in sandbox.
//   development — deployed dev/testing, NOT local. ACH is deployed there via
//                 CircleCI and Ventura points at QA (same Ventura QA database), so
//                 run the local frontend against them without standing the back
//                 ends up yourself. Exception: services without a deployed dev host
//                 (GraphQL, GeoLink) still map `development` to localhost.
//   qa          — deployed QA/staging. Exception: GeoLink qa is still localhost.
//   production  — deployed production. Exception: GraphQL production is a ventura-qa
//                 placeholder pending its own deploy (see the TODO below).
export const apiHostMap = {
  development: 'https://ventura-qa.thinknearhub.com',
  sandbox: 'http://localhost:3000',
  production: 'https://dashboard.thinknear.com',
  qa: 'https://ventura-qa.thinknearhub.com',
};

export const graphQLApiHostMap = {
  development: 'http://localhost:9292/graphql',
  sandbox: 'http://localhost:9292/graphql',
  // TODO: Update this to the right URLs after QA ad production deployment
  production: 'https://ventura-qa.thinknearhub.com',
  qa: 'https://ventura-qa.thinknearhub.com',
};

export const poiManagementApiHostMap = {
  development: 'https://dev.360platform.inmarket.com',
  sandbox: 'https://staging.360platform.inmarket.com',
  // TODO: Update this to the right URLs after QA ad production deployment
  production: 'https://360platform.inmarket.com',
  qa: 'https://staging.360platform.inmarket.com',
};

export const geolinkAudienceCreationServiceApiHostMap = {
  development: 'http://localhost:8080',
  sandbox: 'http://localhost:8080',
  production: 'https://audience-creation-service.aud.inmarket.com',
  qa: 'http://localhost:8080',
};

export const achApiHostMap = {
  development: 'https://activation-control-hub-dev.im-spec-ops.inmarket.com',
  sandbox: 'http://localhost:8080',
  qa: 'https://activation-control-hub-stg.im-spec-ops.inmarket.com',
  production: 'https://activation-control-hub-prod.im-spec-ops.inmarket.com',
};
